import { StyleSheet } from 'react-native'

import { fontFamily } from '../../../theme'
import { DS } from '../../../design-system'

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 24
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10
  },
  cards: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  cardsText: {
    fontFamily: fontFamily.FeatureDeckMedium,
    fontSize: 16,
    color: 'white',
    fontWeight: '500',
    textAlign: 'center',
    maxWidth: 100,
    paddingTop: 12,
    alignSelf: 'center'
  },
  textWin: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textFolded: {
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    fontSize: 10,
    textAlign: 'center',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    lineHeight: 12,
    color: DS.palette['Global/White']
  },
  handWinnerView: {
    paddingTop: 8
  },
  handWinnerText: {
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    fontSize: 10,
    fontWeight: '500',
    lineHeight: 12,
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  potWonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10
  },
  river: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 10,
    gap: 7
  },
  gameOverCardsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    maxWidth: '100%',
    gap: 4,
    marginTop: 8
  }
})
